<template>
  <div class="vacancy-page__files-section">
    <div class="vacancy-page__element vacancy-element" :class="{_open: isOpen(1)}">
      <div class="vacancy-element__head" @click="onToggle(1)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-download-3"
                   width="2.4rem"
                   height="2.4rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">{{ $tVacancy('Useful materials') }}</h4>
        <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>
      <div v-if="windowSizeMixin.width > WINDOW_SIZE_SM || isOpen(1)"
           class="vacancy-element__toggle">
        <div class="vacancy-page__files-list">
          <div v-for="file in files"
               :key="file.id"
               class="vacancy-page__files-list-item">
            <a :href="file.path"
               :download="file.name + '.' + file.ext"
               @click.prevent="downloadItem(file.path, file.name, file.ext)">
              <span>
                <span>{{file.name}}</span>
                <i>
                  <span style="text-transform: uppercase">{{file.ext}}</span>,
                  {{file.size | formatSize}}
                </i>
              </span>
              <BaseSvg name="ico-download-2"/>
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import download from '@/helpers/download'
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'
  import windowSizeMixin from '@/mixins/windowSizeMixin'

  export default {
    name: 'VacancyFilesSection',
    mixins: [windowSizeMixin],
    props: {
      files: null
    },
    data() {
      return {
        WINDOW_SIZE_SM,
        toggleSections: []
      }
    },
    methods: {
      downloadItem(url, name, ext) {
        download(url, name, ext)
      },
      isOpen(id) {
        return this.toggleSections.some(item => item === id)
      },
      onToggle(id) {
        if (window.innerWidth > WINDOW_SIZE_SM) return
        if (this.isOpen(id)) {
          this.toggleSections = this.toggleSections.filter(item => item !== id)
        } else {
          this.toggleSections.push(id)
        }
      }
    }
  }
</script>

<style>

</style>
